import React, { useState, useEffect } from 'react';
import { DollarSign, Plus, Edit2, Trash2, X, Check, Ship, AlertCircle, Star, Copy, Package, Settings, Eye } from 'lucide-react';
import apiService from '../services/api';

// Componente Toast
const Toast = ({ message, type, onClose }) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const duration = 4000;
    const interval = 10;
    const decrement = (100 * interval) / duration;

    const progressTimer = setInterval(() => {
      setProgress((prev) => {
        if (prev <= 0) {
          clearInterval(progressTimer);
          return 0;
        }
        return prev - decrement;
      });
    }, interval);

    const closeTimer = setTimeout(() => {
      onClose();
    }, duration);

    return () => {
      clearInterval(progressTimer);
      clearTimeout(closeTimer);
    };
  }, [onClose]);

  const config = {
    success: {
      bgColor: 'bg-white border border-green-200 shadow-soft',
      progressColor: 'bg-green-500',
      textColor: 'text-green-800'
    },
    error: {
      bgColor: 'bg-white border border-red-200 shadow-soft',
      progressColor: 'bg-red-500',
      textColor: 'text-red-800'
    }
  };

  const currentConfig = config[type] || config.success;

  return (
    <div className={`${currentConfig.bgColor} ${currentConfig.textColor} rounded-xl overflow-hidden min-w-[320px] max-w-md animate-slideIn`}>
      <div className="px-5 py-4 flex items-start gap-3">
        <div className="flex-1 min-w-0">
          <p className="font-medium text-sm leading-relaxed break-words">{message}</p>
        </div>
        <button onClick={onClose} className="flex-shrink-0 hover:bg-ink-100 rounded-lg p-1.5 transition-all duration-200 ml-2">
          <X size={18} />
        </button>
      </div>
      <div className="h-1 bg-ink-100">
        <div className={`h-full ${currentConfig.progressColor} transition-all duration-100 ease-linear`} style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
};

function Tarifas() {
  const [tarifas, setTarifas] = useState([]);
  const [navieras, setNavieras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showDetalleModal, setShowDetalleModal] = useState(false);
  const [navieraSeleccionada, setNavieraSeleccionada] = useState(null);
  const [tarifasNavieraSeleccionada, setTarifasNavieraSeleccionada] = useState([]);
  const [modalMode, setModalMode] = useState('create');
  const [editingTarifa, setEditingTarifa] = useState(null);
  const [toasts, setToasts] = useState([]);
  const [modoAvanzado, setModoAvanzado] = useState(false);
  
  const [formData, setFormData] = useState({
    navieraId: '',
    descripcion: '',
    puerto: '',
    tipoContenedor: '',
    tarifaSinIVA: '',
    incluyeIVA: false,
    esDefault: false,
    tipoEntrega: 'ESTANDAR',
    diaDesde: 1,
    diaHasta: 999,
    tier: ''
  });

  useEffect(() => {
    fetchTarifas();
  }, []);

  const fetchTarifas = async () => {
    try {
      setLoading(true);
      const data = await apiService.get('/tarifas');

      // El endpoint ahora retorna { navieras, tarifas }
      if (data.navieras && data.tarifas) {
        setNavieras(data.navieras);
        setTarifas(data.tarifas);
      } else {
        // Fallback para compatibilidad (si el formato antiguo aún existe)
        setTarifas(data);
      }
    } catch (error) {
      if (error.message !== 'Sesión expirada. Por favor, vuelve a iniciar sesión.') {
        showToast('Error al cargar tarifas', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchNavieras = async () => {
    try {
      const data = await apiService.get('/navieras');
      setNavieras(data);
    } catch (error) {
      if (error.message !== 'Sesión expirada. Por favor, vuelve a iniciar sesión.') {
        showToast('Error al cargar navieras', 'error');
      }
    }
  };

  const showToast = (message, type = 'success') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
  };

  const removeToast = (id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };

  const abrirDetalleNaviera = (naviera, tarifasNaviera) => {
    setNavieraSeleccionada(naviera);
    setTarifasNavieraSeleccionada(tarifasNaviera);
    setShowDetalleModal(true);
  };

  const cerrarDetalleNaviera = () => {
    setShowDetalleModal(false);
    setNavieraSeleccionada(null);
    setTarifasNavieraSeleccionada([]);
  };

  const openModal = (mode, tarifa = null) => {
    setModalMode(mode);
    setModoAvanzado(false);
    
    if (tarifa) {
      if (mode === 'edit') {
        setEditingTarifa(tarifa);
      } else {
        setEditingTarifa(null);
      }
      
      setFormData({
        navieraId: tarifa.navieraId,
        descripcion: tarifa.descripcion,
        puerto: tarifa.puerto || '',
        tipoContenedor: tarifa.tipoContenedor || '',
        tarifaSinIVA: tarifa.tarifaSinIVA,
        incluyeIVA: tarifa.incluyeIVA || false,
        esDefault: mode === 'create' ? false : (tarifa.esDefault || false),
        tipoEntrega: tarifa.tipoEntrega || 'ESTANDAR',
        diaDesde: tarifa.diaDesde || 1,
        diaHasta: tarifa.diaHasta || 999,
        tier: tarifa.tier || ''
      });
      
      if (tarifa.tipoEntrega !== 'ESTANDAR' || tarifa.tier) {
        setModoAvanzado(true);
      }
    } else {
      setEditingTarifa(null);
      setFormData({
        navieraId: '',
        descripcion: '',
        puerto: '',
        tipoContenedor: '',
        tarifaSinIVA: '',
        incluyeIVA: false,
        esDefault: false,
        tipoEntrega: 'ESTANDAR',
        diaDesde: 1,
        diaHasta: 999,
        tier: ''
      });
    }
    setShowModal(true);
  };

 // ✅ FUNCIÓN handleSave CORREGIDA
const handleSave = async () => {
  if (!formData.navieraId || !formData.tarifaSinIVA || !formData.tipoContenedor) {
    showToast('❌ Completa los campos requeridos (Naviera, Tipo Contenedor, Tarifa)', 'error');
    return;
  }

  try {
    const descripcionFinal = formData.descripcion || generarDescripcion();
    
    // ✅ SOLUCIÓN PARA DECIMALES: Redondear correctamente
    const tarifaRedondeada = Math.round(parseFloat(formData.tarifaSinIVA) * 100) / 100;
    
    const dataToSend = {
      navieraId: parseInt(formData.navieraId),
      descripcion: descripcionFinal.trim(),
      puerto: formData.puerto.trim(),
      tipoContenedor: formData.tipoContenedor.trim(),
      tarifaSinIVA: tarifaRedondeada, // ✅ Usa el valor redondeado
      incluyeIVA: Boolean(formData.incluyeIVA),
      esDefault: Boolean(formData.esDefault),
      tipoEntrega: formData.tipoEntrega || 'ESTANDAR',
      diaDesde: parseInt(formData.diaDesde) || 1,
      diaHasta: parseInt(formData.diaHasta) || 999,
      tier: formData.tier ? formData.tier.trim() : null
    };

    const endpoint = modalMode === 'create'
      ? '/tarifas'
      : `/tarifas/${editingTarifa.id}`;

    const method = modalMode === 'create' ? 'post' : 'put';

    await apiService[method](endpoint, dataToSend);

    showToast(
      modalMode === 'create'
        ? '✅ Tarifa creada exitosamente'
        : '✅ Tarifa actualizada exitosamente',
      'success'
    );

    // ✅ SOLUCIÓN PARA REFRESH: Obtener datos actualizados de la API
    const response = await apiService.get('/tarifas');
    if (response.navieras) setNavieras(response.navieras);
    if (response.tarifas) setTarifas(response.tarifas);

    setShowModal(false);

    // ✅ Si el modal de detalle está abierto, actualizarlo
    if (showDetalleModal && navieraSeleccionada) {
      const tarifasDeNaviera = response.tarifas.filter(t => t.naviera === navieraSeleccionada);
      setTarifasNavieraSeleccionada(tarifasDeNaviera);
    }
  } catch (error) {
    console.error('Error al guardar:', error);
    if (error.message !== 'Sesión expirada. Por favor, vuelve a iniciar sesión.') {
      showToast(`❌ ${error.message || 'Error al conectar con el servidor'}`, 'error');
    }
  }
};

// ✅ FUNCIÓN handleDelete CORREGIDA
const handleDelete = async (id) => {
  if (!window.confirm('¿Estás seguro de eliminar esta tarifa?')) return;

  try {
    await apiService.delete(`/tarifas/${id}`);

    showToast('🗑️ Tarifa eliminada exitosamente', 'success');

    // ✅ SOLUCIÓN PARA REFRESH: Obtener datos actualizados de la API
    const response = await apiService.get('/tarifas');
    if (response.navieras) setNavieras(response.navieras);
    if (response.tarifas) setTarifas(response.tarifas);

    // ✅ Actualizar modal de detalle si está abierto
    if (showDetalleModal && navieraSeleccionada) {
      const tarifasDeNaviera = response.tarifas.filter(t => t.naviera === navieraSeleccionada);
      setTarifasNavieraSeleccionada(tarifasDeNaviera);

      // Si ya no hay tarifas, cerrar el modal
      if (tarifasDeNaviera.length === 0) {
        cerrarDetalleNaviera();
      }
    }
  } catch (error) {
    console.error('Error:', error);
    if (error.message !== 'Sesión expirada. Por favor, vuelve a iniciar sesión.') {
      showToast('❌ Error al eliminar tarifa', 'error');
    }
  }
};
  const generarDescripcion = () => {
    let desc = 'DEMORAS';
    if (formData.tipoContenedor) {
      desc += ` ${formData.tipoContenedor}`;
    }
    if (formData.puerto) {
      desc += ` - ${formData.puerto}`;
    }
    return desc.trim();
  };

  // Crear un mapa de navieras con sus tarifas (incluye navieras sin tarifas)
  const tarifasPorNaviera = navieras.reduce((acc, naviera) => {
    // Buscar todas las tarifas de esta naviera
    const tarifasDeNaviera = tarifas.filter(t => t.navieraId === naviera.id);

    acc[naviera.nombre] = {
      naviera: naviera,
      tarifas: tarifasDeNaviera
    };

    return acc;
  }, {});

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-ink-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-ink-900 mx-auto mb-4"></div>
          <p className="text-ink-600">Cargando tarifas...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-8 bg-ink-50 min-h-screen">
      <div className="fixed top-4 right-4 z-50 space-y-3">
        {toasts.map((toast) => (
          <Toast key={toast.id} message={toast.message} type={toast.type} onClose={() => removeToast(toast.id)} />
        ))}
      </div>

      <div className="flex items-center justify-between mb-8 animate-fade-in">
        <div>
          <h1 className="font-display text-3xl text-ink-900 mb-1">Tarifas de Navieras</h1>
          <p className="text-ink-400">Gestiona las tarifas por naviera, puerto y tipo de contenedor</p>
        </div>
        <button
          onClick={() => openModal('create')}
          className="flex items-center gap-2 px-4 py-2 bg-ink-900 text-white rounded-lg hover:bg-ink-800 transition shadow-soft"
        >
          <Plus size={20} />
          <span>Nueva Tarifa</span>
        </button>
      </div>

      {/* Card Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        {Object.entries(tarifasPorNaviera).map(([nombreNaviera, data]) => {
          const { naviera, tarifas: tarifasNaviera } = data;
          const tieneTarifas = tarifasNaviera.length > 0;

          return (
            <div
              key={naviera.id}
              className={`bg-white rounded-xl shadow-soft border overflow-hidden hover:shadow-lifted transition-all duration-300 cursor-pointer group ${
                tieneTarifas ? 'border-ink-200' : 'border-yellow-300 bg-yellow-50'
              }`}
              onClick={() => abrirDetalleNaviera(nombreNaviera, tarifasNaviera)}
            >
              <div className={`px-6 py-5 transition-all ${
                tieneTarifas
                  ? 'bg-white border-l-4 border-ink-900'
                  : 'bg-yellow-50 border-l-4 border-yellow-500'
              }`}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <Ship className={tieneTarifas ? 'text-ink-700' : 'text-yellow-700'} size={28} />
                    <div>
                      <h3 className={`text-xl font-bold ${tieneTarifas ? 'text-ink-900' : 'text-yellow-900'}`}>{nombreNaviera}</h3>
                      <p className={`text-sm ${tieneTarifas ? 'text-ink-600' : 'text-yellow-700'}`}>
                        {tieneTarifas
                          ? `${tarifasNaviera.length} tarifa${tarifasNaviera.length !== 1 ? 's' : ''}`
                          : 'Sin tarifas configuradas'
                        }
                      </p>
                    </div>
                  </div>
                  <Eye className={`${tieneTarifas ? 'text-ink-700' : 'text-yellow-700'} opacity-70 group-hover:opacity-100 transition-opacity`} size={24} />
                </div>
              </div>

              <div className="px-6 py-4 bg-ink-50">
                {tieneTarifas ? (
                  <div className="grid grid-cols-3 gap-4 text-center">
                    <div>
                      <p className="text-xs text-ink-500 mb-1">Tarifas</p>
                      <p className="text-lg font-bold text-ink-900">{tarifasNaviera.length}</p>
                    </div>
                    <div>
                      <p className="text-xs text-ink-500 mb-1">Mínima</p>
                      <p className="text-lg font-bold text-green-600">
                        ${Math.min(...tarifasNaviera.map(t => parseFloat(t.tarifaSinIVA))).toFixed(2)}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-ink-500 mb-1">Máxima</p>
                      <p className="text-lg font-bold text-red-600">
                        ${Math.max(...tarifasNaviera.map(t => parseFloat(t.tarifaSinIVA))).toFixed(2)}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-4">
                    <p className="text-yellow-800 font-semibold text-sm mb-2">
                      Esta naviera no tiene tarifas
                    </p>
                    <p className="text-xs text-yellow-700">
                      Haz clic para agregar una tarifa
                    </p>
                  </div>
                )}
              </div>

              <div className={`px-6 py-3 border-t text-center ${
                tieneTarifas ? 'bg-ink-50 border-ink-200' : 'bg-yellow-100 border-yellow-200'
              }`}>
                <p className={`text-xs font-medium ${
                  tieneTarifas ? 'text-ink-700' : 'text-yellow-800'
                }`}>
                  {tieneTarifas ? 'Click para ver todas las tarifas' : 'Click para agregar tarifa'}
                </p>
              </div>
            </div>
          );
        })}
      </div>

      {tarifas.length === 0 && (
        <div className="text-center py-12">
          <DollarSign size={64} className="mx-auto text-ink-300 mb-4" />
          <p className="text-ink-700 text-lg font-medium">No hay tarifas registradas</p>
          <p className="text-ink-500 text-sm mt-1">Crea tu primera tarifa para comenzar</p>
        </div>
      )}

      {showDetalleModal && (
        <div className="fixed inset-0 bg-ink-900 bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-lifted w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
            {/* Header */}
            <div className="bg-ink-900 px-6 py-5 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Ship className="text-white" size={32} />
                <div>
                  <h2 className="text-2xl font-bold text-white">{navieraSeleccionada}</h2>
                  <p className="text-ink-300 text-sm">
                    {tarifasNavieraSeleccionada.length} tarifa{tarifasNavieraSeleccionada.length !== 1 ? 's registradas' : ' registrada'}
                  </p>
                </div>
              </div>
              <button
                onClick={cerrarDetalleNaviera}
                className="text-white hover:bg-white/20 rounded-lg p-2 transition-all"
              >
                <X size={28} />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6">
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="sticky top-0 bg-ink-50 border-b-2 border-ink-200 z-10">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-bold text-ink-900 uppercase">Descripción</th>
                      <th className="px-4 py-3 text-left text-xs font-bold text-ink-900 uppercase">Detalles</th>
                      <th className="px-4 py-3 text-right text-xs font-bold text-ink-900 uppercase">Tarifa/Día</th>
                      <th className="px-4 py-3 text-center text-xs font-bold text-ink-900 uppercase">Acciones</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-ink-200">
                    {tarifasNavieraSeleccionada.map((tarifa) => (
                      <tr key={tarifa.id} className="hover:bg-ink-50 transition-colors">
                        <td className="px-4 py-4">
                          <div className="flex items-center gap-2">
                            <span className="font-semibold text-ink-900">{tarifa.descripcion || 'DEMORAS'}</span>
                            {tarifa.esDefault && (
                              <Star size={16} fill="currentColor" className="text-yellow-500 flex-shrink-0" />
                            )}
                          </div>
                        </td>
                        <td className="px-4 py-4">
                          <div className="flex flex-wrap gap-2">
                            {tarifa.puerto && (
                              <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-ink-100 text-ink-700 border border-ink-200 rounded-full whitespace-nowrap text-xs font-medium">
                                {tarifa.puerto}
                              </span>
                            )}
                            {tarifa.tipoContenedor && (
                              <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-ink-100 text-ink-700 border border-ink-200 rounded-full whitespace-nowrap text-xs font-medium">
                                {tarifa.tipoContenedor}
                              </span>
                            )}
                            {tarifa.tier && (
                              <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-ink-100 text-ink-700 border border-ink-200 rounded-full whitespace-nowrap text-xs font-medium">
                                {tarifa.tier}
                              </span>
                            )}
                            {tarifa.tipoEntrega && tarifa.tipoEntrega !== 'ESTANDAR' && (
                              <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-ink-100 text-ink-700 border border-ink-200 rounded-full whitespace-nowrap text-xs font-medium">
                                {tarifa.tipoEntrega}
                              </span>
                            )}
                            {(tarifa.diaDesde > 1 || tarifa.diaHasta < 999) && (
                              <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-ink-100 text-ink-700 border border-ink-200 rounded-full whitespace-nowrap text-xs font-medium">
                                Días {tarifa.diaDesde}-{tarifa.diaHasta === 999 ? '∞' : tarifa.diaHasta}
                              </span>
                            )}
                          </div>
                        </td>
                        <td className="px-4 py-4 text-right">
                          <div>
                            <p className="text-lg font-bold text-green-600 whitespace-nowrap">
                              ${parseFloat(tarifa.tarifaSinIVA).toFixed(2)}
                            </p>
                            {tarifa.incluyeIVA && (
                              <p className="text-xs text-blue-600 mt-1">+ IVA</p>
                            )}
                          </div>
                        </td>
                        <td className="px-4 py-4">
                          <div className="flex justify-center gap-2">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                openModal('edit', tarifa);
                              }}
                              className="p-2 text-ink-700 hover:bg-ink-100 rounded-lg transition-colors"
                              title="Editar"
                            >
                              <Edit2 size={18} />
                            </button>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                openModal('create', { ...tarifa, id: null, esDefault: false });
                              }}
                              className="p-2 text-ink-700 hover:bg-ink-100 rounded-lg transition-colors"
                              title="Duplicar"
                            >
                              <Copy size={18} />
                            </button>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(tarifa.id);
                              }}
                              className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                              title="Eliminar"
                            >
                              <Trash2 size={18} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="px-6 py-4 bg-ink-50 border-t border-ink-200 flex justify-between items-center">
              <div className="text-sm text-ink-600">
                <span className="font-semibold">{tarifasNavieraSeleccionada.length}</span> tarifa{tarifasNavieraSeleccionada.length !== 1 ? 's' : ''} en total
              </div>
              <button
                onClick={cerrarDetalleNaviera}
                className="px-6 py-2 bg-ink-900 text-white rounded-lg hover:bg-ink-800 transition"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <div className="fixed inset-0 bg-ink-900 bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-lifted w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="px-6 py-4 border-b border-ink-200 flex items-center justify-between sticky top-0 bg-white z-10">
              <h2 className="text-xl font-bold text-ink-900">
                {modalMode === 'create' ? (editingTarifa ? 'Duplicar Tarifa' : 'Nueva Tarifa') : 'Editar Tarifa'}
              </h2>
              <button onClick={() => setShowModal(false)} className="text-ink-400 hover:text-ink-600">
                <X size={24} />
              </button>
            </div>

            <div className="px-6 py-4 space-y-4">
              <div className="flex items-center justify-between pb-3 border-b border-ink-200">
                <div>
                  <h3 className="text-sm font-semibold text-ink-900">Configuración de Tarifa</h3>
                  <p className="text-xs text-ink-500 mt-0.5">
                    {modoAvanzado ? 'Configuración completa con TIERS y tipos de entrega' : 'Configuración básica para tarifas estándar'}
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => setModoAvanzado(!modoAvanzado)}
                  className={`px-4 py-2 rounded-lg font-medium text-sm transition-all flex items-center gap-2 ${
                    modoAvanzado
                      ? 'bg-ink-100 text-ink-800 border-2 border-ink-300 hover:bg-ink-200'
                      : 'bg-ink-100 text-ink-800 border-2 border-ink-300 hover:bg-ink-200'
                  }`}
                >
                  {modoAvanzado ? (
                    <>
                      <Package size={16} />
                      <span>Modo Simple</span>
                    </>
                  ) : (
                    <>
                      <Settings size={16} />
                      <span>Modo Avanzado</span>
                    </>
                  )}
                </button>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Naviera *</label>
                <select
                  value={formData.navieraId}
                  onChange={(e) => setFormData({ ...formData, navieraId: e.target.value })}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-200 focus:outline-none"
                  required
                >
                  <option value="">Selecciona una naviera</option>
                  {navieras.map((naviera) => (
                    <option key={naviera.id} value={naviera.id}>
                      {naviera.nombre}
                    </option>
                  ))}
                </select>
                <p className="text-xs text-gray-500 mt-1">
                  💡 Si no encuentras tu naviera, créala en el módulo de <strong>Navieras</strong>
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Puerto</label>
                <select
                  value={formData.puerto}
                  onChange={(e) => setFormData({ ...formData, puerto: e.target.value })}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                >
                  <option value="">Todos los puertos</option>
                  <option value="VERACRUZ">Veracruz</option>
                  <option value="LAZARO CARDENAS">Lázaro Cárdenas</option>
                  <option value="MANZANILLO">Manzanillo</option>
                  <option value="ALTAMIRA">Altamira</option>
                  <option value="PROGRESO">Progreso</option>
                  <option value="ENSENADA">Ensenada</option>
                  <option value="GUAYMAS">Guaymas</option>
                  <option value="MAZATLAN">Mazatlán</option>
                </select>
                <p className="text-xs text-gray-500 mt-1">
                  💡 Si no especificas puerto, aplicará para todos
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Contenedor *</label>
                <select
                  value={formData.tipoContenedor}
                  onChange={(e) => setFormData({ ...formData, tipoContenedor: e.target.value })}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  required
                >
                  <option value="">Selecciona el tipo</option>
                  <option value="TODOS">TODOS (Aplica a cualquier tipo)</option>
                  <option value="POR CONTENEDOR">POR CONTENEDOR</option>
                  <option value="POR BL">POR BL</option>
                  
                  <optgroup label="🟦 Dry Container">
                    <option value="20' DV (D2)">20' DV (D2) - Dry Van</option>
                    <option value="40' DV (D4)">40' DV (D4) - Dry Van</option>
                    <option value="20' DC (D2)">20' DC (D2) - Dry Cube</option>
                    <option value="40' DC (D4)">40' DC (D4) - Dry Cube</option>
                    <option value="40' HC (D5)">40' HC (D5) - High Cube</option>
                    <option value="DV">DV (Todos los Dry Van)</option>
                    <option value="DV / HC">DV / HC (Dry Van + High Cube)</option>
                    <option value="DC / HC">DC / HC (Dry + High Cube)</option>
                    <option value="TODOS DRY">TODOS DRY (Cualquier contenedor seco)</option>
                  </optgroup>
                  
                  <optgroup label="❄️ Refrigerado">
                    <option value="20' RF (R2)">20' RF (R2) - Refrigerado</option>
                    <option value="40' RF (R5)">40' RF (R5) - Refrigerado</option>
                    <option value="RF">RF (Todos los refrigerados)</option>
                    <option value="RFSE">RFSE (Refrigerado y equipamiento especial)</option>
                  </optgroup>
                  
                  <optgroup label="📦 Open Top">
                    <option value="20' OT (O2)">20' OT (O2) - Open Top</option>
                    <option value="40' OT (O4)">40' OT (O4) - Open Top</option>
                    <option value="OT">OT (Todos los Open Top)</option>
                  </optgroup>
                  
                  <optgroup label="📐 Flat Rack">
                    <option value="20' FR (F2)">20' FR (F2) - Flat Rack</option>
                    <option value="40' FR (F4)">40' FR (F4) - Flat Rack</option>
                    <option value="FRXC (FC)">FRXC (FC) - Flat Rack x Contenedor</option>
                    <option value="FR">FR (Todos los Flat Rack)</option>
                  </optgroup>
                  
                  <optgroup label="🛢️ Tank">
                    <option value="20' TANK (T2)">20' TANK (T2)</option>
                    <option value="40' TANK (T4)">40' TANK (T4)</option>
                  </optgroup>
                </select>
                <p className="text-xs text-gray-500 mt-1">
                  💡 Puedes seleccionar grupos (ej: "DC / HC" para ambos tipos)
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Descripción</label>
                <input
                  type="text"
                  value={formData.descripcion || generarDescripcion()}
                  onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none bg-gray-50"
                  placeholder="Se genera automáticamente"
                />
                <p className="text-xs text-gray-500 mt-1">
                  💡 Se genera automáticamente según el tipo de contenedor, pero puedes editarla
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tarifa por día SIN IVA (USD) *</label>
                <div className="relative">
                  <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 font-semibold">$</span>
                  <input
                    type="number"
                    step="0.01"
                    value={formData.tarifaSinIVA}
                    onChange={(e) => setFormData({ ...formData, tarifaSinIVA: e.target.value })}
                    className="w-full pl-8 pr-3 py-2.5 border-2 border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    placeholder="0.00"
                    required
                  />
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  💵 Ingresa el precio por día <strong>SIN IVA</strong>. Si el precio ya incluye IVA, márcalo abajo.
                </p>
              </div>

              {modoAvanzado && (
                <div className="bg-ink-50 border-2 border-ink-300 rounded-xl p-5 space-y-4">
                  <div className="flex items-center gap-2 mb-3">
                    <Settings className="text-ink-700" size={20} />
                    <h4 className="text-sm font-bold text-ink-900">Configuración Avanzada</h4>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Entrega</label>
                    <select
                      value={formData.tipoEntrega}
                      onChange={(e) => setFormData({ ...formData, tipoEntrega: e.target.value })}
                      className="w-full px-3 py-2 border-2 border-yellow-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none bg-white"
                    >
                      <option value="ESTANDAR">ESTÁNDAR (Aplica para todos)</option>
                      <option value="CY">CY (Container Yard - Puerto)</option>
                      <option value="DOOR">DOOR (Entrega a Domicilio)</option>
                    </select>
                    <p className="text-xs text-yellow-700 mt-1">
                      🚚 Si es "ESTÁNDAR", aplica sin importar el tipo de entrega
                    </p>
                  </div>

                  <div className="bg-white rounded-lg p-4 border-2 border-yellow-200">
                    <h5 className="text-sm font-semibold text-gray-800 mb-3">📅 Rango de Días (TIER)</h5>
                    <div className="grid grid-cols-3 gap-3">
                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">Nombre del TIER</label>
                        <input
                          type="text"
                          value={formData.tier}
                          onChange={(e) => setFormData({ ...formData, tier: e.target.value })}
                          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none text-sm"
                          placeholder="TIER 1"
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">Día Desde</label>
                        <input
                          type="number"
                          value={formData.diaDesde}
                          onChange={(e) => setFormData({ ...formData, diaDesde: e.target.value })}
                          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none text-sm"
                          placeholder="1"
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">Día Hasta</label>
                        <input
                          type="number"
                          value={formData.diaHasta}
                          onChange={(e) => setFormData({ ...formData, diaHasta: e.target.value })}
                          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none text-sm"
                          placeholder="999"
                        />
                      </div>
                    </div>
                    <div className="mt-3 bg-yellow-50 rounded p-3">
                      <p className="text-xs text-yellow-800">
                        <strong>Ejemplo:</strong> TIER 1 del día <strong>8 al 17</strong> = $145/día<br/>
                        Si dejas <strong>1 a 999</strong>, aplica para cualquier cantidad de días.
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {formData.tarifaSinIVA && (
                <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                  <p className="text-sm font-semibold text-green-900 mb-2">Vista Previa del Cálculo</p>
                  <div className="grid grid-cols-2 gap-3 text-sm">
                    <div>
                      <span className="text-gray-600">Por día (sin IVA):</span>
                      <p className="font-bold text-green-700">${parseFloat(formData.tarifaSinIVA || 0).toFixed(2)}</p>
                    </div>
                    <div>
                      <span className="text-gray-600">Por día (con IVA 16%):</span>
                      <p className="font-bold text-green-700">
                        ${(parseFloat(formData.tarifaSinIVA || 0) * 1.16).toFixed(2)}
                      </p>
                    </div>
                    {modoAvanzado && (
                      <>
                        <div>
                          <span className="text-gray-600">Rango aplicable:</span>
                          <p className="font-bold text-blue-700">Día {formData.diaDesde} al {formData.diaHasta === 999 ? '∞' : formData.diaHasta}</p>
                        </div>
                        <div>
                          <span className="text-gray-600">Tipo entrega:</span>
                          <p className="font-bold text-blue-700">{formData.tipoEntrega}</p>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}

              <div className="space-y-3 pt-2">
                <label className="flex items-center gap-3 p-3 border-2 border-blue-200 rounded-lg cursor-pointer hover:bg-slate-50 transition">
                  <input
                    type="checkbox"
                    checked={formData.incluyeIVA}
                    onChange={(e) => setFormData({ ...formData, incluyeIVA: e.target.checked })}
                    className="w-5 h-5 text-blue-600 rounded focus:ring-2 focus:ring-blue-500"
                  />
                  <div className="flex-1">
                    <span className="text-sm font-semibold text-gray-800">La naviera ya incluye IVA en el precio</span>
                    <p className="text-xs text-gray-500 mt-0.5">
                      Marca esto si el precio ingresado YA tiene el IVA incluido (ej: HAPAG $165 + IVA)
                    </p>
                  </div>
                </label>

                <label className="flex items-center gap-3 p-3 border-2 border-yellow-200 rounded-lg cursor-pointer hover:bg-yellow-50 transition">
                  <input
                    type="checkbox"
                    checked={formData.esDefault}
                    onChange={(e) => setFormData({ ...formData, esDefault: e.target.checked })}
                    className="w-5 h-5 text-yellow-600 rounded focus:ring-2 focus:ring-yellow-500"
                  />
                  <div className="flex-1">
                    <span className="text-sm font-semibold text-gray-800 flex items-center gap-2">
                      <Star size={16} fill="currentColor" className="text-yellow-500" />
                      Tarifa por defecto
                    </span>
                    <p className="text-xs text-gray-500 mt-0.5">
                      Esta será la tarifa sugerida automáticamente para esta naviera
                    </p>
                  </div>
                </label>
              </div>

              <div className="bg-ink-50 border border-ink-200 rounded-lg p-4">
                <div className="flex items-start gap-2">
                  <AlertCircle className="text-ink-700 flex-shrink-0 mt-0.5" size={18} />
                  <div className="text-sm text-ink-800">
                    <p className="font-semibold mb-1">Guía Rápida:</p>
                    <ul className="list-disc list-inside space-y-1 text-xs">
                      <li><strong>Navieras simples</strong> (ej: ZIM): Solo llena lo básico, deja modo simple</li>
                      <li><strong>Navieras con TIERS</strong> (ej: ONE): Usa modo avanzado para rangos de días</li>
                      <li><strong>Múltiples conceptos</strong> (ej: HAPAG): Crea una tarifa por concepto, usa "Duplicar" para copiar</li>
                      <li><strong>Diferentes puertos</strong>: Selecciona el puerto específico o deja "Todos"</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="px-6 py-4 border-t border-ink-200 flex justify-end gap-3 sticky bottom-0 bg-white">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 border border-ink-300 text-ink-700 rounded-lg hover:bg-ink-50 transition"
              >
                Cancelar
              </button>
              <button
                onClick={handleSave}
                className="flex items-center gap-2 px-4 py-2 bg-ink-900 text-white rounded-lg hover:bg-ink-800 transition"
              >
                <Check size={20} />
                <span>Guardar Tarifa</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Tarifas;
